import React from 'react';
import styled from 'styled-components';
import {
  ButtonPrimary,
  screenXsMin,
  screenSmMin,
  screenMdMin,
} from '@spotify-internal/encore-web';

import {
  COLOR_BLACK,
  COLOR_SPOTIFY_GREEN,
} from 'client/components/MarketingPagesShared/styles';
import { MarketingImage } from 'client/components/MarketingPagesShared/MarketingImage';
import { MarketingVideo } from 'client/components/MarketingPagesShared/MarketingVideo';
import { useT } from 'client/i18n/hooks/useT';
import { INTEGRATION_CONNECTION_MENU_MODE } from '../constants';

const VIDEO_DATA = {
  height: 546,
  width: 970,
  imagePath: 'videopartner/videopartner-video-placeholder-image',
  videoId: 't5sKpUgT5M4',
};

const VideoSection = styled.section`
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
  padding: 60px 24px;

  @media (max-width: ${screenMdMin}) {
    padding: 0 52px 60px;
  }

  @media (max-width: ${screenXsMin}) {
    padding: 0 30px 60px;
  }
`;

const VideoTitle = styled.h2`
  margin-bottom: 60px;
  color: ${COLOR_BLACK};
  font-size: 3.125rem;
  line-height: 40px;
  text-align: center;

  @media (max-width: ${screenSmMin}) {
    max-width: 75%;
    margin: 0 auto 60px;
  }

  @media (max-width: ${screenXsMin}) {
    margin: 0 auto 30px;
    max-width: 100%;
    font-size: 2rem;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 1064px;
  margin: 0 auto 58px;
  background: #24203f;

  @media (max-width: ${screenSmMin}) {
    margin: 0 auto 40px;
    width: 100%;
  }
`;

const CreateAccountPrompt = styled.p`
  margin: 0 0 16px;
  color: ${COLOR_BLACK};
  font-weight: bold;
  font-size: 1.125rem;
  line-height: 32px;
  text-align: center;

  @media (max-width: ${screenXsMin}) {
    font-size: 0.875rem;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  max-width: 215px;
  margin: 0 auto;
  button {
    div[class*='ButtonInner'] {
      color: ${COLOR_BLACK};
      background: ${COLOR_SPOTIFY_GREEN};
    }
  }
  button:hover {
    div[class*='ButtonInner'] {
      color: ${COLOR_BLACK};
      background: ${COLOR_SPOTIFY_GREEN};
    }
  }
`;

export function Video({
  onClick,
  currentAuthFormView,
}: {
  onClick: () => void;
  currentAuthFormView: INTEGRATION_CONNECTION_MENU_MODE;
}) {
  const t = useT();
  const isSignup = currentAuthFormView === 'create';

  return (
    <VideoSection>
      <VideoTitle>
        {t(
          'IntegrationConnectionScreen.Video.Title',
          'Upload to Anchor, watch on Spotify',
          'The title on the video section of the Integration Connection Screen'
        )}
      </VideoTitle>
      <VideoWrapper>
        <MarketingVideo
          height={VIDEO_DATA.height}
          title={t(
            'IntegrationConnectionScreen.Video.VideoTitle',
            'Video Podcasts on Spotify',
            'Integration Connection Screen page video title'
          )}
          width={VIDEO_DATA.width}
          youTubeVideoId={VIDEO_DATA.videoId}
        >
          <MarketingImage
            alt={t(
              'IntegrationConnectionScreen.Video.VideoDescription',
              'Woman recording video podcast with a ring light in iPhone',
              'Integration Connection Screen page video description'
            )}
            height={VIDEO_DATA.height}
            imagePath={VIDEO_DATA.imagePath}
            width={VIDEO_DATA.width}
          />
        </MarketingVideo>
      </VideoWrapper>
      <CreateAccountPrompt>
        {t(
          'IntegrationConnectionScreen.Video.CreateAccountPrompt',
          'Create an Anchor account to get started',
          'The prompt to encourage a user to create an Anchor account on the Integration Connection Screen'
        )}
      </CreateAccountPrompt>
      <ButtonWrapper>
        <ButtonPrimary fullWidth colorSet="brightAccent" onClick={onClick}>
          {isSignup
            ? t('Button.Signup', 'Sign up', 'Sign up button text')
            : t('Button.Login', 'Log in', 'Log in button text')}
        </ButtonPrimary>
      </ButtonWrapper>
    </VideoSection>
  );
}
